import { Redirect, Route } from "react-router-dom";
import ChatPage from "../../pages/ChatPage";
import CustomerManagementPage from "../../pages/CustomersManagementPage";
import DashboardPage from "../../pages/DashboardPage";
import DatabaseUserPage from "../../pages/DatabaseUserPage";
import LoginPage from "../../pages/LoginPage";
import PaymentCustomerPage from "../../pages/PaymentCustomerPage";
import SettingPage from "../../pages/SettingPage";
import LayoutNavigateBar from "../LayoutNavigateBar";
import HistoryRecordPage from "../../pages/HistoryRecordPage";
import { useUser } from "../../store/UserStore";
import ComingSoonPage from "../../pages/ComingSoonPage";
import ListBookingPage from "../../pages/ListBookingPage";
import ChatAdminPage from "../../pages/ChatAdminPage";

const AppRoute = ({ component: Component, layout: Layout, ...rest }: any) => {
  return (
    <Route
      {...rest}
      render={(props) => (
        <Layout>
          <Component {...props}></Component>
        </Layout>
      )}
    ></Route>
  );
};

export default function Routes() {
  const user = useUser();
  return (
    <>
      {(user.userData?.role === "doctor" ||
        user.userData?.role === "admin") && (
        <AppRoute
          path="/chat/:bookingId"
          exact
          layout={LayoutNavigateBar}
          component={ChatPage}
        />
      )}
      {(user.userData?.role === "doctor" ||
        user.userData?.role === "admin") && (
        <AppRoute
          path="/chat"
          exact
          layout={LayoutNavigateBar}
          component={ListBookingPage}
        />
      )}
      {(user.userData?.role === "doctor" ||
        user.userData?.role === "admin") && (
        <AppRoute
          path="/manage"
          layout={LayoutNavigateBar}
          component={CustomerManagementPage}
        />
      )}
      {(user.userData?.role === "doctor" ||
        user.userData?.role === "admin") && (
        <AppRoute
          path="/"
          exact
          layout={LayoutNavigateBar}
          component={DashboardPage}
        />
      )}

      {user.userData?.role === "admin" && (
        <AppRoute
          path="/setting"
          exact
          layout={LayoutNavigateBar}
          component={SettingPage}
        />
      )}
      {user.userData?.role === "admin" && (
        <AppRoute
          path="/adminChat/:uid"
          exact
          layout={LayoutNavigateBar}
          component={ChatAdminPage}
        />
      )}
      {user.userData?.role === "admin" && (
        <AppRoute
          path="/payment-customer"
          layout={LayoutNavigateBar}
          exact
          component={PaymentCustomerPage}
        />
      )}
      {user.userData?.role === "admin" && (
        <AppRoute
          path="/database-customer"
          layout={LayoutNavigateBar}
          exact
          component={DatabaseUserPage}
        />
      )}
      {user.userData?.role === "admin" && (
        <AppRoute
          path="/history"
          layout={LayoutNavigateBar}
          exact
          component={HistoryRecordPage}
        />
      )}
      {user.userData?.role === "operator" && (
        <AppRoute
          path="*"
          layout={LayoutNavigateBar}
          component={ComingSoonPage}
        />
      )}

      {user.userData === undefined ? (
        <>
          {/* <Route path="/login" exact component={LoginPage} /> */}
          <Redirect to="/login" />
          <Route path="*" component={LoginPage} />
        </>
      ) : (
        <Redirect to="/" />
      )}
    </>
  );
}
